module.exports = __webpack_public_path__ + "static/img/7-2.af896dfc.png";